<template>
  <div>
    <b-alert
      v-model="showAlert"
     class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      :variant="alertValues.variant"
      dismissible
  
    >
      {{alertValues.msg}}
    </b-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: "AlertMessage",
  data() {
    return {
      showBottom: false,
      showTop: false,
       dismissSecs: 10,
        dismissCountDown: 0,
    };
  },

computed: {
  showAlert: {
    get() {
     return this.$store.state.showAlert
    },
    set(value) {
      // MODIFY THIS MUTATION
      this.$store.commit("SET_SHOW_ALERT", value)
    }
  },
  ...mapState({
      alertValues: (state) => state.alertValues,
        
    })
},
methods:{

}
};
</script>
<style scoped></style>